<script setup lang="ts">
import { computed } from "vue";
import { useAppStore } from "@/store/modules/app";
import { useThemeStore } from "@/store/modules/theme";

defineOptions({
  name: "GlobalContent",
});

interface Props {
  /** Show padding for content */
  showPadding?: boolean;
}

withDefaults(defineProps<Props>(), {
  showPadding: true,
});

const appStore = useAppStore();
const themeStore = useThemeStore();

const transitionName = computed(() =>
  themeStore.page.animate ? themeStore.page.animateMode : "",
);
</script>

<template>
  <RouterView v-slot="{ Component, route }">
    <Transition
      :name="transitionName"
      mode="out-in"
      @before-leave="appStore.setContentXScrollable(true)"
      @after-enter="appStore.setContentXScrollable(false)"
    >
      <component
        :is="Component"
        v-if="appStore.reloadFlag"
        :key="route.path"
        :class="{ 'p-16px': showPadding }"
        class="custom-bgc flex-grow bg-layout transition-300"
      />
    </Transition>
  </RouterView>
</template>

<style>
.custom-bgc {
  background: #f3f3f3;
}
</style>
